import React from 'react'

export default function File(props) {
  return (
    <svg viewBox="0 0 36 40" width="36" height="40" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M35.5 16.207L19.793.5H2A1.5 1.5 0 00.5 2v36A1.5 1.5 0 002 39.5h32a1.5 1.5 0 001.5-1.5V16.207z"
          stroke="#C5CEC7"
          fill="#FFF"
        />
        <path d="M20 1l15 15H22a2 2 0 01-2-2V1z" fill="#C5CEC7" />
      </g>
    </svg>
  )
}
